import { useTexts } from './useTexts';

export function useGetDateFilterOptions() {
  const texts = useTexts();
  return [
    { label: `${texts.dateFilterOptions.lastMonth}`, value: 1, monthsDiff: 1 },
    {
      label: `${texts.dateFilterOptions.last3Months}`,
      value: 2,
      monthsDiff: 3,
    },
    {
      label: `${texts.dateFilterOptions.last6Months}`,
      value: 3,
      monthsDiff: 6,
    },
    { label: `${texts.dateFilterOptions.lastYear}`, value: 4, monthsDiff: 12 },
  ];
}
